import { render, staticRenderFns } from "./checkStudent.vue?vue&type=template&id=643f3bb5&"
import script from "./checkStudent.vue?vue&type=script&lang=js&"
export * from "./checkStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports